import { AxiosInstance } from 'axios';
import RedisApiAxiosInstance from 'services/api/RedisApiAxiosInstance/RedisApiAxiosInstance';
import { loadRemoteModule } from 'moduleFederation/moduleFederationRuntime';
import { Config } from '../../config';

type InitApiService = (axiosInstance: AxiosInstance, baseUrl: string | false) => void;

const initDatabasesMFEApiService = async () => {
  try {
    const {
      initSmApiService,
      initDatabasesApiService,
      initDatabaseEndpointsApiService,
      initKycApiService,
      initResourceLinkApiService,
      initCloudMetricsApiService,
      initTagsApiService
    } = await loadRemoteModule<{
      initSmApiService: InitApiService;
      initDatabasesApiService: InitApiService;
      initDatabaseEndpointsApiService: InitApiService;
      initKycApiService: InitApiService;
      initResourceLinkApiService: InitApiService;
      initCloudMetricsApiService: InitApiService;
      initTagsApiService: InitApiService;
    }>('databases/initApiService');
    initSmApiService?.(RedisApiAxiosInstance, !Config.IS_RELATIVE_API && Config.CURRENT_ORIGINS.SM);
    initDatabasesApiService?.(
      RedisApiAxiosInstance,
      !Config.IS_RELATIVE_API && Config.CURRENT_ORIGINS.DATABASE
    );
    initDatabaseEndpointsApiService?.(
      RedisApiAxiosInstance,
      !Config.IS_RELATIVE_API && Config.CURRENT_ORIGINS.DATABASE_ENDPOINTS
    );
    initKycApiService?.(
      RedisApiAxiosInstance,
      !Config.IS_RELATIVE_API && Config.CURRENT_ORIGINS.KYC.replace('/api', '')
    );
    initResourceLinkApiService?.(
      RedisApiAxiosInstance,
      !Config.IS_RELATIVE_API && Config.CURRENT_ORIGINS.PRIVATE_LINK
    );
    initCloudMetricsApiService?.(
      RedisApiAxiosInstance,
      !Config.IS_RELATIVE_API && Config.CURRENT_ORIGINS.METRICS
    );
    initTagsApiService?.(
      RedisApiAxiosInstance,
      !Config.IS_RELATIVE_API && Config.CURRENT_ORIGINS.TAGGING
    );
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('cannot load initDatabasesMFEApiService', e);
  }
};

export default initDatabasesMFEApiService;
